export default __webpack_public_path__ + "static/media/avatar-male-1.01922a7c.jpg";